import React from "react";

type HeartToggleButtonProps = {
  isActive: boolean;
  onClick: () => void;
};

const HeartToggleButton: React.FC<HeartToggleButtonProps> = ({
  isActive,
  onClick,
}) => (
  <button
    onClick={onClick}
    className={`fixed top-8 left-8 z-50 w-12 h-12 rounded-full shadow-md border border-gray-200 flex items-center justify-center text-2xl transition-colors duration-200
      ${
        isActive
          ? "bg-red-50 text-red-600 shadow-red-100"
          : "bg-white text-gray-400"
      }`}
    title="좋아요 매물만 보기"
    type="button"
  >
    ❤️
  </button>
);

export default HeartToggleButton;
